import { useEffect, useCallback, useRef } from "react";

const ScreenSizeChecker = ({ onScreenSizeChange }) => {
  const previousState = useRef(null);
  const timeout = useRef(null);

  const checkScreenSize = useCallback(() => {
    const isSmall = window.innerWidth < 1200;
    if (previousState.current !== isSmall) {
      previousState.current = isSmall;
      onScreenSizeChange(isSmall);
    }
  }, [onScreenSizeChange]);

  const debounceResize = useCallback(() => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(checkScreenSize, 100);
  }, [checkScreenSize]);

  useEffect(() => {
    window.addEventListener("resize", debounceResize);
    checkScreenSize();
    return () => {
      window.removeEventListener("resize", debounceResize);
      clearTimeout(timeout.current);
    };
  }, [debounceResize, checkScreenSize]);

  return null;
};

export default ScreenSizeChecker;
